import { takeEvery, put } from 'redux-saga/effects';
import { all, call, select } from 'typed-redux-saga';
import * as api from 'data/api';
import { HttpStatus, ResponseCode } from 'data/api/response-codes';
import { actions } from './slice';
import * as statelessActions from './actions';
import * as selectors from './selectors';

function* uploadSingleFile(file) {
  const captchaUuid = yield* select(selectors.getCaptchaUuid);
  const response = yield* call(api.uploadReportAttachment, file, captchaUuid);

  if (response.status === HttpStatus.Forbidden) {
    yield put(actions.addFileToRetry({
      file
    }));
    return null;
  }

  if (response.code === ResponseCode.InvalidCaptchaToken) {
    yield put(actions.addFileToRetry({
      file
    }));
    yield put(actions.resetCaptchaUuid());
    return null;
  }

  if ('errors' in response) {
    yield put(actions.addFailedFilename({
      filename: file.name
    }));
    return null;
  }

  return {
    id: response.attachment.temp_uuid,
    fileName: file.name
  };
}

export function* uploadFilesRequest(_ref) {
  let {
    payload
  } = _ref;
  const responses = yield* all(payload.files.map(uploadSingleFile));
  const savedFiles = responses.filter(file => !!file);
  yield put(actions.uploadFilesSuccess({
    savedFiles
  }));
}
export function* submitFormRequest(_ref2) {
  let {
    payload
  } = _ref2;
  const captchaUuid = yield* select(selectors.getCaptchaUuid);
  const response = yield* call(api.sendIntellectualPropertyInfringement, payload.formData, captchaUuid);

  if (response.status === HttpStatus.Forbidden) {
    yield put(actions.setFormData({
      formData: payload.formData
    }));
    return;
  }

  if (response.code === ResponseCode.InvalidCaptchaToken) {
    yield put(actions.setFormData({
      formData: payload.formData
    }));
    yield put(actions.resetCaptchaUuid());
    return;
  }

  if ('errors' in response) {
    yield put(actions.submitFormFailure({
      errors: response.errors
    }));
    return;
  }

  yield put(actions.submitFormSuccess());
}
export function* continueUploading() {
  const filesToRetry = yield* select(selectors.getFilesToRetry);

  if (filesToRetry.length) {
    yield put(actions.uploadFilesRequest({
      files: filesToRetry
    }));
    return;
  }

  const formData = yield* select(selectors.getFormData);

  if (formData) {
    yield put(actions.submitFormRequest({
      formData
    }));
  }
}
export default function* saga() {
  yield takeEvery(actions.uploadFilesRequest, uploadFilesRequest);
  yield takeEvery(actions.submitFormRequest, submitFormRequest);
  yield takeEvery([actions.setCaptchaUuid, statelessActions.continueFormSubmit], continueUploading);
}